module.exports = __webpack_public_path__ + "img/logo3.85329fe8.png";